import React, { useState, useEffect } from "react";
import { getImageUrl } from "src/Common/common";
import { WO_TYPE_LIST } from "src/Common/contants";

const CalendarSideBarTicket = ({ ticket }) => {
  const [WOStatus, setWOStatus] = useState(ticket.status);
  const [isHide, setIsHide] = useState(false);

  const [shouldRender, setShouldRender] = useState(!isHide);

  useEffect(() => {
    if (!isHide) {
      setShouldRender(true);
    } else {
      const timeout = setTimeout(() => setShouldRender(false), 300);
      return () => clearTimeout(timeout);
    }
  }, [isHide]);

  useEffect(() => {
    const today = new Date();
    const startDate = new Date(ticket.startDate);
    if (ticket.status === 100) setWOStatus("Closed");
    if (startDate < today && ticket.status !== 100) {
      setWOStatus("Open");
    } else if (startDate > today) {
      setWOStatus("Scheduled");
    }
  }, [ticket.status, ticket.startDate]);

  const convertDate = (dateString) => {
    const date = new Date(dateString);

    const options = { month: "long" };
    const month = date.toLocaleString("en-US", options);
    const day = String(date.getDate()).padStart(2, "0");

    const formatted = `${month} ${day}`;
    return formatted;
  };

  const getSidebarTicketBageStyle = (status) => {
    if (status === "Open") return "bg-[#FFE500] text-[#404A6E]";
    else if (status === "Closed") return "bg-[#C5E9C6] text-[#404A6E]";
    else if (status === "Scheduled") return "bg-[#0065FD] text-[#FFF]";
  };

  return (
    <div className="flex flex-col border-b">
      {shouldRender && (
        <div
          className={`transition-all duration-300 ease-in-out overflow-hidden ${
            isHide ? "max-h-0 opacity-0" : "max-h-[500px] opacity-100"
          }`}
        >
          <div className="flex w-full justify-between px-4 py-4 space-x-2">
            <div className="flex flex-col space-y-4">
              <div className="flex flex-col">
                <h2 className="text-lg font-bold text-[#0065FD]">
                  {ticket.company}
                </h2>
                <span className="text-[16px] text-[#408CFD]">
                  WO#: {ticket.number}
                </span>
              </div>

              <div className="flex flex-col space-y-1">
                <div className="flex items-center space-x-1">
                  <img
                    className="object-contain w-[14px] h-[14px]"
                    src={getImageUrl("/images/sidemenu/date.png")}
                  />
                  <span className="font-[14px]">
                    {ticket.billedData
                      ? `${convertDate(ticket.startDate)} - ${convertDate(
                          ticket.billedData[0].date
                        )}`
                      : convertDate(ticket.startDate)}
                  </span>
                </div>
              </div>

              <div className="flex flex-row items-start space-x-[6px]">
                <div className="bg-[#BFD9FF] text-[12px] font-bold rounded-[12px] w-[90px] px-2 py-1 text-center">
                  {WO_TYPE_LIST[ticket.type]}
                </div>
                <div
                  className={`px-2 py-1 text-[12px] w-[90px] text-center border border-none rounded-xl ${getSidebarTicketBageStyle(
                    WOStatus
                  )} text-semibold`}
                >
                  {WOStatus}
                </div>
              </div>
            </div>

            <div className="flex flex-col">
              <a
                href={`/work/${ticket.id}`}
                target="_blank"
                rel="noreferrer"
                className="rounded-[8px] border border-[#E6E7EC] text-[16px] w-[125px] py-[10px] text-center uppercase"
              >
                details
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CalendarSideBarTicket;
